export function RangeIterator(start: number, end: number) {
  return {
    start,
    end,
    [Symbol.iterator]: function* () {
      let i = this.start;

      while (i <= this.end) {
        yield i;
        i += 1;
      }
    },
  };
}

export function ReverseRangeIterator(start: number, end: number) {
  return {
    start,
    end,
    [Symbol.iterator]: function* () {
      let i = this.end;

      while (i >= this.start) {
        yield i;
        i -= 1;
      }
    },
  };
}
